export default "__VITE_ASSET__BOJ9pNcz__"